import { ActiveRecord, sources } from '@mysidewalk/active-record';
import FeatureClass from '../system-metadata/FeatureClass.js';
/**
 * @property {number} id
 * @property {number[]} columns
 * @property {number} coverageRatio
 * @property {number} coverageFeatureCount
 * @property {number} layerFeatureCount
 * @property {system-metadata.FeatureClass} featureClass
 */
class ColumnCoverage extends ActiveRecord {
    initialize(props) {
        super.initialize(props);
        this.featureClass = new FeatureClass(props.featureClass);
    }
    /**
     * @param {number[]} columnIds
     * @return {Promise<ColumnCoverage[]>}
     */
    static allForColumns(columnIds, params = {}) {
        return ColumnCoverage.all({
            columns__overlap: columnIds.join(','),
            include: 'feature_class',
            ...params,
        });
    }
}
ColumnCoverage.$AR = {
    url: '',
    SourceClass: sources.ActiveRecordJSONAPISource,
};
export default ColumnCoverage;
